import { render, staticRenderFns } from "./pagamento.vue?vue&type=template&id=6773b754"
import script from "./pagamento.vue?vue&type=script&lang=ts"
export * from "./pagamento.vue?vue&type=script&lang=ts"
import style0 from "./pagamento.vue?vue&type=style&index=0&id=6773b754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports